import { FACEBOOK_CLIENT_ID, GOOGLE_CLIENT_ID, MODAL_TYPES } from 'app/commons/constants'
import { ICON_FACEBOOK, ICON_GOOGLE } from 'app/commons/constants/image.const'
import * as Utils from 'app/commons/helpers/utils'
import * as authActions from 'app/store/auth/authAction'
import { messageErrorAction } from 'app/store/messageError/messageErrorSlice'
import { modalCreateActions } from 'app/store/modal/modalSlice'
import { getAndCheckTokenCaptCha } from 'app/utils/authentication'

import React from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { OldSocialLogin as SocialLogin } from 'react-social-login'
import { toast } from 'react-toastify'

import _get from 'lodash.get'

import './style.scss'

function ButtonSocial() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { executeRecaptcha } = useGoogleReCaptcha()
  const enableCaptchaVerification = useSelector((state) => state.configuration.data?.enable_captcha_verification)

  const handleSocialLogin = async (socialInfo, err) => {
    if (err) {
      if (err.error === 'popup_closed_by_user') {
        dispatch(
          messageErrorAction.setMessageErrors({
            messageError: t('common.loginSocial.loginSocialIncognito'),
            isOpen: true,
          })
        )
      }
      return null
    }
    if (socialInfo) {
      const profile = _get(socialInfo, '_profile', {})
      const provider = _get(socialInfo, '_provider', '')
      const accessToken =
        provider === 'facebook' ? _get(socialInfo, '_token.accessToken', '') : _get(socialInfo, '_token.idToken', '')
      const params = {
        email: profile.email,
        provider,
        access_token: accessToken,
      }

      let xRecaptchaToken
      if (enableCaptchaVerification) {
        xRecaptchaToken = await getAndCheckTokenCaptCha(executeRecaptcha, 'login_social')
      }

      dispatch(
        authActions.handleLoginSocial({
          params,
          xRecaptchaToken,
          callback: (res) => {
            if (!res?.success) {
              if (res.error_code === 403) {
                toast.error(res.message || t('common.loginSocial.suspended'))
              }
              if (res.status === 400 && res.error) {
                toast.error(res.error)
              }
              if (!res.object) {
                const newParams = {
                  email: profile.email,
                  firstName: profile.firstName,
                  lastName: profile.lastName,
                  accessToken,
                  provider,
                }
                dispatch(
                  modalCreateActions.openModal({
                    typeModal: MODAL_TYPES.SIGNUP,
                    modalProps: { initialValues: newParams },
                  })
                )
              } else {
                const data = res.object
                const paramsMergeSocial = {
                  country_code: data.country_code,
                  email: data.email,
                  phone: data.phone,
                  first_name: data.first_name,
                  last_name: data.last_name,
                  businessName: data.business_name,
                  referral_code: data.referred_by,
                  access_token: accessToken,
                  provider,
                  socialToken: accessToken,
                }
                dispatch(
                  modalCreateActions.openModal({
                    typeModal: MODAL_TYPES.MERGE_MODAL,
                    modalProps: { initialValues: paramsMergeSocial },
                  })
                )
              }
            } else {
              if (res.access_token) {
                const decodeToken = Utils.parseJwt(res.access_token)
                const accountId = +decodeToken?.company_id || +decodeToken.customer_id
                dispatch(authActions.handleGetAuth({ accountId }))
                dispatch(modalCreateActions.closeModal())
              }
            }
          },
        })
      )
    }
  }
  return (
    <div className="Box-Content-Social">
      <SocialLogin
        provider="facebook"
        autoCleanUri
        appId={FACEBOOK_CLIENT_ID}
        callback={(socialInfo, err) => handleSocialLogin(socialInfo, err)}
        className="facebook-login"
      >
        <button className="Button social-facebook">
          <img src={ICON_FACEBOOK} alt="facebook" />
          <span>{t('common.login.facebook')}</span>
        </button>
      </SocialLogin>
      <SocialLogin
        provider="google"
        autoCleanUri
        appId={GOOGLE_CLIENT_ID}
        callback={(socialInfo, err) => handleSocialLogin(socialInfo, err)}
        className="google-login"
      >
        <button className="Button social-google">
          <img src={ICON_GOOGLE} alt="google" width={22} height={22} />
          <span>{t('common.login.google')}</span>
        </button>
      </SocialLogin>
    </div>
  )
}

export default ButtonSocial
